// extracted by mini-css-extract-plugin
export default {"emptyTreatmentsList":"style--emptyTreatmentsList--95bfc9","button":"style--button--8c9fc9"};